import React, { useMemo } from 'react'
import { Redirect } from 'react-router-dom'

import { AutenticacaoContainer } from 'src/componentes'
import { recuperarRotaBasePorVisao } from 'src/componentes/autenticacao/funcoes'

export const Redirecionador: React.FC = () => {
  const {
    perfil: { perfis }
  } = AutenticacaoContainer.useContainer()

  const recuperarRotaDaVisao = useMemo(() => {
    return recuperarRotaBasePorVisao(perfis)
  }, [perfis])

  // Perfil sem visao mapeada nao tem rota base: sem esta guarda o Redirect
  // receberia undefined e o catch-all das rotas devolveria para '/', em loop.
  // Rota literal para nao importar de './index', que importa este arquivo.
  if (!recuperarRotaDaVisao) return <Redirect to="/entrar" />

  return <Redirect to={recuperarRotaDaVisao} />
}
